import axios from 'axios'
import global from '@/global/variable.js'

// 获取骨料限制车数
export function getAllowOne(data) {
  const url = global.requestUrl + '/projectConfig/list'
  return axios.get(url)
}

// 更新骨料限制车数
export function updateAllowOne(data) {
  const url = global.requestUrl + '/projectConfig/update'
  return axios.post(url, data)
}

// 获取骨料货车当前车数
export function getCurrentOne(data) {
  const url = global.requestUrl + '/truckAccess/exitCar'
  return axios.get(url)
}

// 更新当前骨料货车车数
export function updateCurrentOne(data) {
  const url = global.requestUrl + '/truckAccess/setExistCar?number=' + data.number
  return axios.get(url)
}

